import { addSearchParamsToUrl } from '@fourthwall/utils/dist/links'

export const addProtocol = (url: string) => {
  return !url.startsWith('https://') ? `https://${url}` : url
}

export const stripProtocol = (url: string) => {
  return url.replace(/^https?:\/\//, '')
}

export type UtmSourceValue = 'onboarding'

export const addUtmSourceParamToUrl = (url: string | URL, sourceValue: UtmSourceValue) =>
  addSearchParamsToUrl(url, { utm_source: sourceValue })
